<template>
  <div class="page-gantt-wrap">
    <van-nav-bar :border="false"
                 title="项目进度优先级"
                 left-arrow
                 @click-left="$router.back()"
    />
    <!-- <div class="gantt-wrap">
        <div class="jindu-wrap item" v-for="(item,index) in projectList" :key="index">
            <div class="title">项目名称</div>
            <van-slider class="jindu-slider" v-model="value" disabled bar-height=".25rem" active-color="#D32F2F" inactive-color="#eee" >
                <template #button>
                    <div class="custom-button">{{value}}%</div>
                </template>
            </van-slider>
            <div class="priority-wrap">
                <span>优先级：</span>
                <div class="priority">
                    <div class="level a">紧急</div>
                    <div class="level ">重要</div>
                    <div class="level ">一般</div>
                </div>
            </div>
        </div>
        <div class="jindu-wrap item">
            <div class="title">项目名称</div>
            <van-slider class="jindu-slider" v-model="value" disabled bar-height=".25rem" active-color="#D32F2F" inactive-color="#eee" >
                <template #button>
                    <div class="custom-button">{{value}}%</div>
                </template>
            </van-slider>
            <div class="priority-wrap">
                <span>优先级：</span>
                <div class="priority">
                    <div class="level">紧急</div>
                    <div class="level b">重要</div>
                    <div class="level ">一般</div>
                </div>
            </div>
        </div>
    </div> -->

  </div>
</template>

<script>


export default {
  data() {
    return {
      projectList: [1, 2, 3],
      value: 10,
      age: 18
    }
  },
  mounted() {

  },

  // 离开时
  deactivated() {

  },
  // 进入页面时
  activated() {

  },
  methods: {
    handlecount() {
      this.age++
    }
  },
}
</script>

<style lang="less" scoped>
.page-gantt-wrap {
  font-size: 0.34rem;
}

.gantt-wrap {
  padding: 0 .28rem .4rem;

  .item {
    margin-top: 0.8rem;

    .title {
      font-size: 0.36rem;
    }

    .priority-wrap {
      margin-top: 0.9rem;
      display: flex;
    }

    .priority {
      display: flex;

      .level {
        width: 0.8rem;
        margin-right: 0.2rem;
        background-color: #d3d3d3;
        border-radius: 0.07rem;
        font-size: 0.3rem;
        color: #333;
        text-align: center;

        &.a {
          color: #fffefe;
          background-color: #ff0000;
        }

        &.b {
          color: #fffefe;
          background-color: #ff7200;
        }

        &.c {
          color: #fffefe;
          background-color: #0090ff;
        }
      }
    }
  }

}

.jindu-slider {
  margin-top: 0.4rem;
  opacity: 1;

  /deep/ .van-slider__button-wrapper {
    margin-top: 0.6rem;
  }

  /deep/ .custom-button {
    font-size: 0.3rem;
    color: #666666;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/Gantt.vue